import { render, staticRenderFns } from "./HeadBusinessPersons.vue?vue&type=template&id=2ea8c4aa&scoped=true&"
import script from "./HeadBusinessPersons.vue?vue&type=script&lang=js&"
export * from "./HeadBusinessPersons.vue?vue&type=script&lang=js&"
import style0 from "./HeadBusinessPersons.vue?vue&type=style&index=0&id=2ea8c4aa&scoped=true&lang=css&"
import style1 from "./HeadBusinessPersons.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ea8c4aa",
  null
  
)

export default component.exports